import Backbone from "backbone";


export default Backbone.View.extend({

    initialize: function() {
      this.node = this.$el;
      this.content = this.node.find(".js-Content");
      this.iconPlus = this.node.find(".js-moreContentNav-plus");
      this.iconLess = this.node.find(".js-moreContentNav-less");
      this.isOpened = false;
    },

    events: {
      "click .js-ContentToggle": "open"
    },

    open: function(e) {
      e.preventDefault();
      this.render();
    },

    getCssClass: function() {
      if (this.isOpened) {
        this.content.prop("className", "CategoryNav-moreContentNav js-Content");
        this.iconPlus.addClass("js-moreContentNav--active");
        this.iconLess.removeClass("js-moreContentNav--active");
        this.isOpened = false;
      } else {
        this.content.prop("className", "CategoryNav-moreContentNav js-Content js-moreContentNav--active");
        this.iconLess.addClass("js-moreContentNav--active");
        this.iconPlus.removeClass("js-moreContentNav--active");
        this.isOpened = true;
      }
    },

    render: function() {
      this.getCssClass();
    }

  });
